import axios from "axios"
import axiosRetry from "axios-retry"
export async function getStatusForSweetETiles (token, url, delay) {

  await new Promise(resolve => setTimeout(resolve, delay))

  const axiosClient = axios.create()
  const retryCondition = (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response.status === 403
    )
  }
  axiosRetry(axiosClient, {retries: 200, retryDelay: axiosRetry.exponentialDelay, retryCondition})

  const tilesStatus = await axiosClient
    .get(url, {
      headers: { "authorizationToken": token }
    })

  return { status: tilesStatus.status }
}
